
import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import MaintenanceDetail from "./maintenance-detail.vue";

const guidance = namespace("guidance");

@Component({ components: { MaintenanceDetail } })
export default class ComMaintenanceItem extends Vue {
  @Prop({ default: () => ({}), type: Object }) modelData: any;
  @Prop({ default: "", type: String }) modelCode: string;
  @guidance.Action queryMaintenanceItemDetail;
  @guidance.Mutation setMaintenanceItemDetailLoading;
  showDetail = false;
  get maintenanceItemList() {
    return Object.entries(this.modelData || {}).map(item => {
      return {
        category: item[0],
        itemList: item[1]
      };
    });
  }
  itemDetailData: any = {};
  handleShowItemDetail(maintenanceId) {
    this.showDetail = true;
    this.setMaintenanceItemDetailLoading(true);
    this.queryMaintenanceItemDetail({
      modelCode: this.modelCode,
      maintenanceId: maintenanceId
    })
      .then(data => {
        this.itemDetailData = data.data;
      })
      .finally(() => {
        this.setMaintenanceItemDetailLoading(false);
      });
  }
}
